import { render } from "./KoiStatus.vue?vue&type=template&id=4f5291be&scoped=true&ts=true"
import script from "./KoiStatus.vue?vue&type=script&lang=ts"
export * from "./KoiStatus.vue?vue&type=script&lang=ts"

import "./KoiStatus.vue?vue&type=style&index=0&id=4f5291be&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5291be"]])

export default __exports__